import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  Fragment,
} from "react";
import { Typography, Stack, Box, Grid, Button, Divider } from "@mui/material";
import { useQuery } from "@apollo/client";
import moment from "moment";
//Icons
import { SiMicrosoftexcel } from "react-icons/si";
import { BsPrinter } from "react-icons/bs";
//Srcs
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import school from "../../Assets/goglobal-school.png";
import symbol from "../../Assets/tacteing.jpg";
import {
  ConvertToEnglishWordsDollar,
  ConvertToKhmerWordsDollar,
} from "../Include/ReadCurrency";

import {
  getKhmerMonth,
  getKhmerNumber,
  currencyFormat,
} from "../../Function/DynamicFn";
import { GET_MONTHLY_AMOUNT_PAID } from "../../Schema/Report";

function loop_elements(countValue) {
  let row = [];
  for (let i = 0; i < countValue?.length; i++) {
    row.push(i);
  }
  return row;
}

export default function StudStatisticMonthlyFee({
  programmeVal,
  academicYearVal,
  tableRef,
  classGroupVal,
  filterMonthYear,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [tableReport, setTableReport] = useState([]);

  //  ================ Print PDF ===========================
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const componentRef = useRef(null);
  const reactToPrintContent = () => {
    return componentRef.current;
  };

  const reactToPrintTrigger = () => {
    return (
      <Button
        onClick={handleOpen}
        className="btn-create"
        startIcon={

          <BsPrinter alt="CreateIcon" className="icon-add" />
        }
      >
        Print
      </Button>
    );
  };

  // ====================== End Print PDF ===============================
  const { refetch } = useQuery(GET_MONTHLY_AMOUNT_PAID, {
    variables: {
      academicYearId: academicYearVal?.id,
      programmeId: programmeVal?.id,
      classgroupId: classGroupVal?.id,
      filterYear: moment(filterMonthYear).format("YYYY"),
      filterMonth: moment(filterMonthYear).format("M"),
    },
    onCompleted: ({ getMonthlyAmoutPaid }) => {

      setTableData(getMonthlyAmoutPaid);
      setLoading(false);

      if (getMonthlyAmoutPaid?.dataByGrade?.length > 0) {
        let rowOfReport = [];
        getMonthlyAmoutPaid?.dataByGrade?.map((gradeElement, indexGrade) => {
          if (gradeElement?.dataByClass?.length > 0) {
            //
            gradeElement?.dataByClass?.map((classElement, indexClass) => {
              const allRow = {
                gradeName: gradeElement?.gradeName,
                className: classElement?.className,
                roomNumber: classElement?.roomNumber,
                studyShift: classElement?.studyShift,
                totalAmountByClass: classElement?.totalAmountByClass,
                totalByDay: classElement?.totalByDay,
              };

              if (rowOfReport?.length === 0) {
                rowOfReport?.push(allRow);
              } else if (rowOfReport?.length > 0) {
                let filterHaveGradeClass = rowOfReport?.filter(
                  (e) =>
                    e?.gradeName === allRow?.gradeName &&
                    e?.className === allRow?.className
                );

                if (filterHaveGradeClass?.length === 0) {
                  rowOfReport?.push(allRow);
                }
              }
            });
          } else {
            const allRow = {
              gradeName: gradeElement?.gradeName,
              className: "",
              roomNumber: "",
              studyShift: "",
              totalByDay: [],
            };

            if (rowOfReport?.length === 0) {
              rowOfReport?.push(allRow);
            } else if (rowOfReport?.length > 0) {
              let filterHaveGradeClass = rowOfReport?.filter(
                (e) =>
                  e?.gradeName === allRow?.gradeName &&
                  e?.className === allRow?.className
              );

              if (filterHaveGradeClass?.length === 0) {
                rowOfReport?.push(allRow);
              }
            }
          }
        });
        setTableReport([...rowOfReport]);
      } else {
        setTableReport([]);
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [
    programmeVal?.id,
    academicYearVal?.id,
    filterMonthYear,
    classGroupVal?.id,
  ]);

  const totalAmountByClasses = (gradeName, className) => {
    let totalStudent = 0;
    let newArray = tableReport?.filter(
      (e) => e?.gradeName === gradeName && e?.className === className
    );

    newArray?.map((firstData, index) => {
      firstData?.totalByDay?.map((month) => {
        totalStudent += month?.totalAmount;
      });
    });
    return { totalStudent };
  };

  const totalAmountByGrade = (gradeName) => {
    let totalStudent = 0;
    let newArray = tableReport?.filter((e) => e?.gradeName === gradeName);

    newArray?.map((firstData, index) => {
      firstData?.totalByDay?.map((month) => {
        totalStudent += month?.totalAmount;
      });
    });
    return { totalStudent };
  };

  const totalAmountStudents = () => {
    let totalAmount = 0;
    let newArray = tableReport;

    newArray?.map((firstData, index) => {
      firstData?.totalByDay?.map((month) => {
        totalAmount += month?.totalAmount;
      });
    });
    return { totalAmount };
  };

  const totalAmount = totalAmountStudents()?.totalAmount;

  // const totalStudentMonthOfProgram = (programmeName) => {

  //   let newRow = [];
  //   let newArray = tableReport?.filter((e) => e?.programmeName === programmeName);

  //   //=============
  //   newArray?.map((firstData, index) => {

  //     if (index === 0) {
  //       firstData?.totalByDay?.map((month, indexMonth) => {
  //         let allRow = {
  //           key: index + indexMonth + 1,
  //           monthName: month?.monthName,
  //           totalAmount: month?.totalAmount
  //         }
  //         newRow.push(allRow);
  //       })
  //     }

  //     if (index > 0) {
  //       firstData?.totalByDay?.map((month, indexMonth) => {
  //         //
  //         let filterNameMonth = newRow?.filter((elem) => elem?.monthName === month?.monthName);

  //         if (filterNameMonth?.length > 0) {
  //           newRow.map((element, index) => {
  //             if (element?.key === index + indexMonth + 1) {
  //               element.totalAmount += month.totalAmount;
  //             }
  //           })
  //         }

  //       })
  //     }

  //   })

  //   return newRow
  // }

  const startYear = academicYearVal?.title?.slice(0, 4) || "";
  const endYear = academicYearVal?.title?.slice(5, 9) || "";
  // console.log("tablersass", tableData);

  return (
    <Box sx={{ marginTop: "20px" }}>
      <Box
        sx={{ bgcolor: "#fff", borderRadius: "10px" }}
        className="dibursement-print-container"
      >
        <Grid container>
          <Grid item xs={3}>
            <Stack direction="column">
              <img
                src={school}
                alt="school"
                className="logo-size"
                // style={{ width: "100px" }}
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack direction="column">
              <Stack justifyContent="center" alignItems="center">
                <Typography className="disbursement-title-kh">
                  ព្រះរាជាណាចក្រកម្ពុជា
                </Typography>
                <Typography className="disbursement-title">
                  Kingdom Of Cambodia
                </Typography>
                <Typography className="disbursement-title-kh">
                  ជាតិ សាសនា ព្រះមហាក្សត្រ
                </Typography>
                <Typography className="disbursement-title">
                  Nation Region King
                </Typography>
                <img src={symbol} alt="" width="110px" />
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>

        {/* <Stack direction="row" width="100%" justifyContent="right" spacing={3}>
            <Typography className="number-text">លេខ ៖</Typography>
            <Typography className="number-text">026 / 24</Typography>
          </Stack> */}

        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          marginTop="15px"
          spacing={0.5}
        >
          <Typography className="disbursement-table-title">
            ស្ថិតិសិស្សតាមថ្នាក់សម្រាប់ឆ្នាំសិក្សា{" "}
            {getKhmerNumber(startYear) + " - " + getKhmerNumber(endYear)}
          </Typography>
          <Typography className="disbursement-table-title-header">
            កម្រិត​ {classGroupVal?.title}
          </Typography>
        </Stack>
        <Box sx={{ marginTop: "10px" }} justifyContent="center">
          <Box ref={tableRef}>
            <table style={{ width: "100%", display: "none" }}>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  ព្រះរាជាណាចក្រកម្ពុជា
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  Kingdom Of Cambodia
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  ជាតិ សាសនា ព្រះមហាក្សត្រ
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  Nation Region King
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td
                  colSpan={6 + tableData?.totalNum?.length}
                  style={{ textAlign: "center" }}
                >
                  ស្ថិតិសិស្សបង់ថ្លៃការសិក្សាសម្រាប់ឆ្នាំសិក្សា ២០២៤-២០២៥
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
            </table>
            <table className="table-cash">
              <thead className="thead-cash">
                <tr>
                  <td
                    className="title-table-stat"
                    style={{ width: "1%" }}
                    rowSpan={2}
                  >
                    ល.រ
                  </td>
                  <td
                    className="title-table-stat"
                    style={{ width: "5%" }}
                    rowSpan={2}
                  >
                    កម្រិត
                  </td>
                  <td
                    className="title-table-stat"
                    style={{ width: "3%" }}
                    rowSpan={2}
                  >
                    ថ្នាក់
                  </td>
                  <td
                    className="title-table-stat"
                    style={{ width: "3%" }}
                    rowSpan={2}
                  >
                    វេន
                  </td>
                  <td
                    className="title-table-stat"
                    style={{ width: "3%" }}
                    rowSpan={2}
                  >
                    បន្ទប់
                  </td>
                  <td
                    className="title-table-stat"
                    style={{ width: "3%" }}
                    rowSpan={2}
                  >
                    សរុប {getKhmerMonth(moment(filterMonthYear)?.format("M"))}
                  </td>
                  {/* <td className="title-table-stat" style={{ width: "3%" }} rowSpan={2}>
                    ផែនការ
                  </td> */}
                  <td
                    className="title-table-stat"
                    colSpan={tableData?.totalNum?.length}
                  >
                    {getKhmerMonth(moment(filterMonthYear)?.format("M"))}
                  </td>
                </tr>
                <tr>
                  {tableData?.totalNum?.map((e, index) => {
                    return (
                      <td
                        className="title-table-stat"
                        key={index}
                        style={{
                          width: `${77 / tableData?.totalNum?.length || 1}%`,
                        }}
                      >
                        {e?.dayName}
                      </td>
                    );
                  })}
                </tr>
                <tr style={{ backgroundColor: "rgb(236, 236, 224)" }}>
                  <td className="title-table-stat tb-txt-blueb" colSpan={5}>
                    Total All
                  </td>
                  <td className="title-table-stat tb-txt-redb" align="right">
                    {currencyFormat(totalAmountStudents()?.totalAmount)}
                  </td>
                  {/* <td className="title-table-stat">
                    0
                  </td> */}
                  {tableData?.totalNum?.map((d, index) => {
                    return (
                      <td
                        className="title-table-stat tb-txt-redb"
                        align="right"
                        style={{ width: "2%" }}
                        key={index}
                      >
                        {currencyFormat(d?.totalAmount)}
                      </td>
                    );
                  })}
                </tr>
              </thead>

              <tbody className="tbody-cash">
                <>
                  {tableData?.dataByGrade?.map((grade, indexGrade) => {
                    //=========== filter grade name ============
                    const rowGrade = tableReport?.filter(
                      (e) => e?.gradeName === grade?.gradeName
                    );
                    return loop_elements(rowGrade)?.map(
                      (elementClass, indexClassGroup) =>
                        indexClassGroup === 0 ? (
                          <React.Fragment key={indexClassGroup}>
                            <tr>
                              <td className="title-table-stat">
                                {indexClassGroup + 1}
                              </td>
                              <td
                                className="title-table-stat"
                                rowSpan={rowGrade?.length}
                              >
                                {rowGrade[elementClass]?.gradeName}
                              </td>
                              <td className="title-table-stat">
                                {rowGrade[elementClass]?.className}
                              </td>
                              <td className="title-table-stat">
                                {rowGrade[elementClass]?.studyShift}
                              </td>
                              <td className="title-table-stat">
                                {rowGrade[elementClass]?.roomNumber}
                              </td>
                              <td className="title-table-stat" align="right">
                                {currencyFormat(
                                  totalAmountByClasses(
                                    rowGrade[elementClass]?.gradeName,
                                    rowGrade[elementClass]?.className
                                  )?.totalStudent
                                )}
                              </td>
                              {/* <td className="title-table-stat">
                              0
                            </td> */}
                              {rowGrade[elementClass]?.totalByDay?.map(
                                (monthElement, indexMonth) => (
                                  <React.Fragment key={indexMonth}>
                                    <td
                                      className="title-table-stat"
                                      align="right"
                                    >
                                      {currencyFormat(
                                        monthElement?.totalAmount
                                      )}
                                    </td>
                                  </React.Fragment>
                                )
                              )}
                            </tr>
                          </React.Fragment>
                        ) : loop_elements(rowGrade)?.length ===
                          indexClassGroup + 1 ? (
                          <React.Fragment key={indexClassGroup}>
                            <tr key={indexClassGroup}>
                              <td className="title-table-stat">
                                {indexClassGroup + 1}
                              </td>
                              <td className="title-table-stat">
                                {rowGrade[elementClass]?.className}
                              </td>
                              <td className="title-table-stat">
                                {rowGrade[elementClass]?.studyShift}
                              </td>
                              <td className="title-table-stat">
                                {rowGrade[elementClass]?.roomNumber}
                              </td>
                              <td className="title-table-stat" align="right">
                                {currencyFormat(
                                  totalAmountByClasses(
                                    rowGrade[elementClass]?.gradeName,
                                    rowGrade[elementClass]?.className
                                  )?.totalStudent
                                )}
                              </td>
                              {/* <td className="title-table-stat">
                                0
                              </td> */}
                              {/* <td className="title-table-stat">
                                {rowGrade[elementClass]?.totalAmountByClass}
                              </td>
                              <td className="title-table-stat">
                                {currencyFormat(totalAmountStudentByGradeAndClass(rowGrade[elementClass]?.gradeName, rowGrade[elementClass]?.className)?.totalAmount)}
                              </td> */}
                              {rowGrade[elementClass]?.totalByDay?.map(
                                (monthElement, indexMonth) => (
                                  <React.Fragment key={indexMonth}>
                                    <td
                                      className="title-table-stat"
                                      align="right"
                                    >
                                      {currencyFormat(
                                        monthElement?.totalAmount
                                      )}
                                    </td>
                                  </React.Fragment>
                                )
                              )}
                            </tr>

                            <tr
                              key={indexClassGroup}
                              style={{ backgroundColor: "#ecece0" }}
                            >
                              <td
                                className="title-table-stat"
                                align="center"
                                colSpan={5}
                              >
                                សរុប {rowGrade[elementClass]?.gradeName}
                              </td>
                              <td className="title-table-stat" align="right">
                                {currencyFormat(
                                  totalAmountByGrade(
                                    rowGrade[elementClass]?.gradeName
                                  )?.totalStudent
                                )}
                              </td>
                              {/* <td className="title-table-stat" align="center">
                                0
                              </td> */}
                              {/* <td className="title-table-stat" align="center">
                                aaa
                              </td> */}
                              {/* <td className="title-table-stat" align="center" style={{ color: "red", fontWeight: "bold" }}>
                                {(totalStudentByGrades(rowGrade[elementClass]?.gradeName)?.totalStudent)}
                              </td>
                              <td className="title-table-stat" align="center" style={{ color: "red", fontWeight: "bold" }}>
                                {currencyFormat(totalAmountStudentByGrades(rowGrade[elementClass]?.gradeName)?.totalAmount)}
                              </td> */}

                              {/* console.log("rowGrade==", rowGrade[elementClass]?.totalByDay) */}
                              {rowGrade[elementClass]?.totalByDay?.map(
                                (monthElement, indexMonth) => (
                                  <React.Fragment key={indexMonth}>
                                    <td className="title-table-stat">
                                      {/* aaab */}
                                    </td>
                                  </React.Fragment>
                                )
                              )}
                            </tr>
                          </React.Fragment>
                        ) : (
                          <React.Fragment key={indexClassGroup}>
                            <tr key={indexClassGroup}>
                              <td className="title-table-stat">
                                {indexClassGroup + 1}
                              </td>
                              <td className="title-table-stat">
                                {rowGrade[elementClass]?.className}
                              </td>
                              <td className="title-table-stat">
                                {rowGrade[elementClass]?.studyShift}
                              </td>
                              <td className="title-table-stat">
                                {rowGrade[elementClass]?.roomNumber}
                              </td>
                              <td className="title-table-stat" align="right">
                                {currencyFormat(
                                  totalAmountByClasses(
                                    rowGrade[elementClass]?.gradeName,
                                    rowGrade[elementClass]?.className
                                  )?.totalStudent
                                )}
                              </td>
                              {/* <td className="title-table-stat">
                                0
                              </td> */}
                              {/* <td className="title-table-stat">
                                {rowGrade[elementClass]?.totalAmountByClass}
                              </td>
                              <td className="title-table-stat">
                                {currencyFormat(totalAmountStudentByGradeAndClass(rowGrade[elementClass]?.gradeName, rowGrade[elementClass]?.className)?.totalAmount)}
                              </td> */}
                              {rowGrade[elementClass]?.totalByDay?.map(
                                (monthElement, indexMonth) => (
                                  <React.Fragment key={indexMonth}>
                                    <td
                                      className="title-table-stat"
                                      align="right"
                                    >
                                      {currencyFormat(
                                        monthElement?.totalAmount
                                      )}
                                    </td>
                                  </React.Fragment>
                                )
                              )}
                            </tr>
                          </React.Fragment>
                        )
                    );
                  })}
                </>
              </tbody>
            </table>

            <table style={{ width: "100%", display: "none" }}>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}></td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Financial Affairs Director
                </td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  អ្នករៀបចំ
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Prepare by
                </td>
              </tr>
            </table>
          </Box>
          <Box sx={{ marginTop: "10px" }}>
            <Grid container spacing={0.5}>
              <Grid item xs={2.5}>
                <Typography className="number-text">
                  ចំនួនទឹកប្រាក់ជាអក្សរ ៖
                </Typography>
              </Grid>
              <Grid item xs={9.5}>
                <Typography className="number-text">
                  {ConvertToKhmerWordsDollar(totalAmount)}
                </Typography>
              </Grid>
              <Grid item xs={2.5}>
                <Typography className="number-text">
                  Amount in words ៖
                </Typography>
              </Grid>
              <Grid item xs={9.5}>
                <Typography className="number-text">
                  {ConvertToEnglishWordsDollar(totalAmount)}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ marginTop: "20px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center">
                  <Typography className="disbursement-table-title">
                    នាយិការង
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Deputy of School Principal
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    វេត ស្រីម៉ៅ
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={1}>
                  <Typography className="disbursement-table-title">
                    ប្រធានកិច្ចការហិរញ្ញវត្ថុ
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Financial Affairs Director
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ខូវ ស៊ូខេង
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={2}>
                  <Typography className="disbursement-table-title">
                    អ្នករៀបចំ
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Prepare by
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ស៊ុន ផាត់សន
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
